var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRename = function SvgIconRename(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.18h-6.25l1.68-1.68H17zm-10 0v-2.11l6.563-6.523q.312-.273.585 0l1.485 1.445q.234.313 0 .625L9.07 16.18zM17.82 4.5H6.18q-.743 0-1.211.469-.47.468-.469 1.21V17.82q0 .704.469 1.211.507.47 1.21.469H17.82q.704 0 1.172-.469.508-.508.508-1.21V6.18q0-.743-.508-1.211-.468-.47-1.172-.469"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRename);
export { ForwardRef as ReactComponent };